<!-- ============ TOOLBAR ============ -->
<div class="cd-toolbar">
  <div class="cd-toolbar-left">
    <span class="cd-toolbar-title">Contacts</span>
    <span class="cd-count-badge" *ngIf="ContactList.length">{{ ContactList.length }}</span>
  </div>

  <div class="cd-toolbar-right">
    <div class="cd-view-switch" *ngIf="!calledInUIC" role="group" aria-label="View switcher">
      <button type="button" class="cd-view-btn" [class.active]="currentView === 'card'"
        (click)="currentView = 'card'" title="Card View" aria-label="Card View">
        <i class="bi bi-grid-fill"></i>
      </button>
      <button type="button" class="cd-view-btn" [class.active]="currentView === 'list'"
        (click)="currentView = 'list'" title="List View" aria-label="List View">
        <i class="bi bi-list-ul"></i>
      </button>
    </div>

    <button type="button" class="btn btn-sm btn-primary cd-add-btn" (click)="addContact()">
      <i class="bi bi-plus-lg me-1"></i> Add Contact
    </button>
  </div>
</div>

<!-- ============ FORM PANEL ============ -->
<div class="cd-form-panel" *ngIf="editMode" @accordionAnimation>
  <div class="cd-form-header">
    <span class="cd-form-header-icon"><i class="bi bi-person-lines-fill"></i></span>
    <div class="cd-form-header-text">
      <h6 class="cd-form-title">
        {{ contactDetailForm.controls.contactId.value ? 'Edit Contact Detail' : 'Add Contact Detail' }}
      </h6>
    </div>
    <button type="button" class="cd-form-close" (click)="resetForm()" [disabled]="loading" aria-label="Close">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>

  <div class="cd-form-body">
    <form [formGroup]="contactDetailForm" novalidate>
      <div class="row g-3">

        <!-- Person Name -->
        <div class="col-12 col-md-6 col-xl-3">
          <label class="cd-label">
            Person Name <span class="cd-required">*</span>
          </label>
          <input type="text" class="form-control form-control-sm"
            [formControl]="contactDetailForm.controls.personName" placeholder="e.g. Ramesh Kulkarni">
          <app-form-errors [control]="contactDetailForm.controls.personName"></app-form-errors>
        </div>

        <!-- Designation / Relationship - label is host-configurable -->
        <div class="col-12 col-md-6 col-xl-3" *ngIf="showDesignation">
          <label class="cd-label">
            {{ designationLabel }} <span class="cd-required" *ngIf="designationRequired">*</span>
          </label>

          <!-- Consignment forms keep their fixed designation list -->
          <select class="form-select form-select-sm" *ngIf="consignmentForm" formControlName="designation">
            <option value="">-- Select Designation --</option>
            <option *ngFor="let designation of designationList" [value]="designation">
              {{ designation }}
            </option>
          </select>

          <!-- Value-list dropdown (Staff Detail uses this as Relationship) -->
          <ng-select class="cd-ng-select" *ngIf="!consignmentForm && designationAsDropdown"
            [items]="relationshipOptions" formControlName="designation"
            [placeholder]="designationPlaceholder" [clearable]="true" appendTo="body" dropdownPosition="bottom">
          </ng-select>

          <!-- Designation (Supplier / Customer / Company): dropdown when the value list has items -->
          <ng-select class="cd-ng-select"
            *ngIf="!consignmentForm && !designationAsDropdown && designationOptions.length"
            [items]="designationOptions" formControlName="designation"
            placeholder="Select designation" [clearable]="true" appendTo="body" dropdownPosition="bottom">
          </ng-select>

          <!-- Free-text designation when no value list items are configured -->
          <input type="text" class="form-control form-control-sm"
            *ngIf="!consignmentForm && !designationAsDropdown && !designationOptions.length" formControlName="designation"
            [placeholder]="designationPlaceholder" maxlength="50">

          <app-form-errors [control]="contactDetailForm.controls.designation"
            [fieldName]="designationLabel"></app-form-errors>
        </div>

        <!-- Contact Type (Value List driven) - Staff Detail page only -->
        <div class="col-12 col-md-6 col-xl-3" *ngIf="showContactType">
          <label class="cd-label">Contact Type</label>
          <ng-select class="cd-ng-select" [items]="contactTypeOptions" formControlName="contactType"
            placeholder="Select contact type" [clearable]="true" appendTo="body" dropdownPosition="bottom">
          </ng-select>
          <app-form-errors [control]="contactDetailForm.controls.contactType"></app-form-errors>
        </div>

        <!-- Mobile -->
        <div class="col-12 col-md-6 col-xl-3">
          <label class="cd-label">Mobile</label>
          <input class="form-control form-control-sm" type="tel" formControlName="mobile"
            placeholder="e.g. 9876543210">
          <app-form-errors [control]="contactDetailForm.controls.mobile"></app-form-errors>
        </div>

        <!-- Phone -->
        <div class="col-12 col-md-6 col-xl-3">
          <label class="cd-label">Phone</label>
          <input class="form-control form-control-sm" type="tel" formControlName="phone"
            placeholder="e.g. +91-20-1234-5678">
          <app-form-errors [control]="contactDetailForm.controls.phone"></app-form-errors>
        </div>

        <!-- Email -->
        <div class="col-12 col-md-6 col-xl-3">
          <label class="cd-label">Email ID</label>
          <input type="email" class="form-control form-control-sm" formControlName="emailId"
            placeholder="e.g. name@company.com">
          <app-form-errors [control]="contactDetailForm.controls.emailId"></app-form-errors>
        </div>

        <!-- Mark as default -->
        <div class="col-12 col-md-6 col-xl-3 d-flex align-items-end">
          <label class="cd-default-toggle" for="cdIsDefault">
            <input class="form-check-input" type="checkbox" id="cdIsDefault" formControlName="isDefault">
            <span class="cd-default-text">
              <span class="cd-default-title">
                <i class="bi bi-check-circle-fill me-1"></i>Set as default contact
              </span>
              <small class="cd-default-hint">Any other default contact will be cleared</small>
            </span>
          </label>
        </div>

      </div>
    </form>
  </div>

  <div class="cd-form-footer">
    <button type="button" class="btn btn-sm btn-light cd-btn-cancel" (click)="resetForm()" [disabled]="loading">
      Cancel
    </button>
    <button type="button" class="btn btn-sm btn-primary" *ngIf="!loading" (click)="submitForm()">
      <i class="bi bi-check2 me-1"></i>{{ calledInUIC ? 'Save' : 'Submit' }}
    </button>
    <button type="button" class="btn btn-sm btn-primary" *ngIf="loading" disabled>
      <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
      Processing...
    </button>
  </div>
</div>

<!-- ============ LOADING ============ -->
<div class="cd-loading" *ngIf="isDataLoading">
  <div class="spinner-border spinner-border-sm text-primary" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
  <span class="cd-loading-text">Loading contacts...</span>
</div>

<!-- ============ EMPTY STATE ============ -->
<div class="cd-empty" *ngIf="!isDataLoading && !ContactList.length && !calledInUIC">
  <div class="cd-empty-icon"><i class="bi bi-person-lines-fill"></i></div>
  <h6 class="cd-empty-title">No contact details yet</h6>
  <p class="cd-empty-text">Add a contact so your team knows who to reach out to.</p>
  <button type="button" class="btn btn-sm btn-primary" (click)="addContact()" *ngIf="!editMode">
    <i class="bi bi-plus-lg me-1"></i> Add Contact
  </button>
</div>

<!-- ============ CARD VIEW ============ -->
<div *ngIf="currentView === 'card' && !calledInUIC && ContactList.length && !isDataLoading"
  class="contacts-grid-container">
  <div class="contact-card-wrapper" *ngFor="let contact of ContactList">
    <div class="cd-card">

      <div class="cd-card-header">
        <div class="cd-avatar" [attr.data-initial]="(contact.personName || '?').charAt(0).toUpperCase()">
          {{ (contact.personName || '?').charAt(0).toUpperCase() }}
        </div>

        <div class="cd-card-heading" [class.cd-heading-no-chips]="!hasHeaderChips(contact)">
          <h6 class="cd-card-name" [title]="contact.personName">{{ contact.personName || 'Unnamed Contact' }}</h6>
          <div class="cd-chip-row" *ngIf="hasHeaderChips(contact)">
            <span class="cd-chip" *ngIf="showContactType && contact.contactType"
              [class.cd-chip-danger]="isEmergency(contact.contactType)"
              [class.cd-chip-type]="!isEmergency(contact.contactType)" [title]="contact.contactType">
              <i class="bi" [ngClass]="isEmergency(contact.contactType) ? 'bi-exclamation-triangle-fill' : 'bi-tag-fill'"></i>
              {{ contact.contactType }}
            </span>
            <span class="cd-chip cd-chip-default" *ngIf="contact.isDefault === 1">
              <i class="bi bi-check-circle-fill"></i> Default
            </span>
          </div>
        </div>

        <div class="dropdown cd-card-menu">
          <button class="cd-kebab" data-bs-toggle="dropdown" aria-label="Actions" aria-expanded="false">
            <i class="bi bi-three-dots-vertical"></i>
          </button>
          <ul class="dropdown-menu dropdown-menu-end shadow-sm">
            <li>
              <button type="button" class="dropdown-item"
                (click)="handleActionClick({actionName: 'Edit', rowData: contact})">
                <i class="bi bi-pencil-square me-2"></i>Edit
              </button>
            </li>
            <li>
              <button type="button" class="dropdown-item"
                (click)="defaultCheckBox({rowData: contact, isChecked: contact.isDefault !== 1})">
                <i class="bi bi-check-circle me-2"></i>{{ contact.isDefault === 1 ? 'Remove Default' : 'Set as Default' }}
              </button>
            </li>
            <li>
              <hr class="dropdown-divider">
            </li>
            <li>
              <button type="button" class="dropdown-item text-danger"
                (click)="handleActionClick({actionName: 'Delete', rowData: contact})">
                <i class="bi bi-trash3 me-2"></i>Delete
              </button>
            </li>
          </ul>
        </div>
      </div>

      <div class="cd-card-body">
        <div class="cd-info-row" *ngIf="showDesignation && contact.designation">
          <span class="cd-info-icon"><i class="bi" [ngClass]="designationIcon"></i></span>
          <div class="cd-info-text">
            <small class="cd-info-label">{{ designationLabel }}</small>
            <span class="cd-info-value" [title]="contact.designation">{{ contact.designation }}</span>
          </div>
        </div>

        <div class="cd-info-row" *ngIf="contact.mobile">
          <span class="cd-info-icon"><i class="bi bi-phone"></i></span>
          <div class="cd-info-text">
            <small class="cd-info-label">Mobile</small>
            <a class="cd-info-value cd-link" [href]="'tel:' + contact.mobile" [title]="contact.mobile">
              {{ contact.mobile }}
            </a>
          </div>
        </div>

        <div class="cd-info-row" *ngIf="contact.phone">
          <span class="cd-info-icon"><i class="bi bi-telephone"></i></span>
          <div class="cd-info-text">
            <small class="cd-info-label">Phone</small>
            <a class="cd-info-value cd-link" [href]="'tel:' + contact.phone" [title]="contact.phone">
              {{ contact.phone }}
            </a>
          </div>
        </div>

        <div class="cd-info-row" *ngIf="contact.emailId">
          <span class="cd-info-icon"><i class="bi bi-envelope"></i></span>
          <div class="cd-info-text">
            <small class="cd-info-label">Email</small>
            <a class="cd-info-value cd-link" [href]="'mailto:' + contact.emailId" [title]="contact.emailId">
              {{ contact.emailId }}
            </a>
          </div>
        </div>

        <div class="cd-info-empty" *ngIf="!contact.mobile && !contact.phone && !contact.emailId">
          <i class="bi bi-info-circle me-1"></i> No contact channels captured
        </div>
      </div>

    </div>
  </div>
</div>

<!-- ============ LIST VIEW ============ -->
<div *ngIf="currentView === 'list' && !isDataLoading" class="cd-list-wrap">
  <app-color-table [columns]="listColumns" [tableData]="ContactList" [enableActionColumn]="true"
    [actionColumnLabel]="'Action'"
    [actionOptions]="[{actionName:'Edit',actionIcon:'fa fa-edit'},{actionName:'Delete',actionIcon:'fa fa-trash'},{actionName:'Default', actionIcon:'fa fa-check-circle'}]"
    (actionClick)="handleActionClick($event)" enableBadge="RoleCode">
  </app-color-table>
</div>
